var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSorting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.693,
    height: 19.447,
    viewBox: "0 0 22.693 19.447",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#393939;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M186.153,392.9h-8.909c-.762,0-.81-.05-.812-.8,0-.586.022-1.174-.007-1.759-.025-.517.183-.715.7-.707,1.153.019,2.307.006,3.461.006h14.469c.792,0,.838.047.84.833q0,.823,0,1.645c0,.723-.06.782-.774.782Q190.636,392.906,186.153,392.9Z",
    transform: "translate(-176.424 -389.638)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M183.764,454.019q-3.261,0-6.521,0c-.688,0-.749-.063-.752-.743q0-.879,0-1.758c0-.673.078-.754.745-.755q3.913,0,7.826,0,2.637,0,5.274,0c.663,0,.755.093.76.749,0,.6-.015,1.21.006,1.814.018.508-.183.705-.7.7C188.187,454.009,185.975,454.019,183.764,454.019Z",
    transform: "translate(-176.482 -443.818)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M182.173,515.059q-2.47,0-4.939,0c-.682,0-.736-.058-.739-.754,0-.511,0-1.022,0-1.533,0-.962,0-.962.992-.962h6.074c1.192,0,2.385.016,3.576-.007.543-.011.751.2.72.74-.033.585-.006,1.173-.008,1.759,0,.7-.06.756-.738.757Q184.643,515.062,182.173,515.059Z",
    transform: "translate(-176.486 -497.927)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M309.783,459.778v-2.934q0-2.667,0-5.335c0-.721.064-.785.766-.791.132,0,.265.007.4,0,.484-.031.669.183.666.674-.016,2.308-.007,4.616-.007,6.924,0,.488,0,.976,0,1.624.546-.535,1.011-.96,1.44-1.419.354-.38.631-.355.991.007.8.81.816.8-.012,1.615-.942.931-1.9,1.849-2.819,2.8-.384.4-.661.367-1.033-.013q-1.549-1.58-3.148-3.112c-.346-.333-.376-.588-.025-.944.842-.857.834-.874,1.7,0,.319.321.608.673.91,1.01Z",
    transform: "translate(-291.948 -443.778)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorting);
export default __webpack_public_path__ + "static/media/sorting.e8a5656785a27a3db5cbd3b0515e0f9a.svg";
export { ForwardRef as ReactComponent };